import { DEEPFAKE_NOTIFICATIONS_POLLING_ASYNC } from '../Polling/constants'

const initialState = {
  deepfake: {
    newLiveAlertsSinceLastVisitTimestamp: null,
  },
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case DEEPFAKE_NOTIFICATIONS_POLLING_ASYNC.SUCCESS: {
      const { newLiveAlertsSinceLastVisitTimestamp } = action.payload.data

      return {
        ...state,
        deepfake: {
          newLiveAlertsSinceLastVisitTimestamp,
        },
        error: null,
      }
    }
    case DEEPFAKE_NOTIFICATIONS_POLLING_ASYNC.ERROR:
      return {
        ...state,
        error: action.error,
      }
    default:
      return state
  }
}
